<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<div class="flex justify-center items-center gap-14">
  <!-- The mocks only specify the sizes for mobile & desktop, split the difference in between -->
  <button
    class="w-10 md:w-12 lg:w-14 h-10 md:h-12 lg:h-14 flex flex-col items-center justify-center"
    (click)="onPreviousIndex()"
    (mouseenter)="checkScreenWidth() > 600 && previousHovered.set(true)"
    (mouseleave)="previousHovered.set(false)"
  >
    @if (!previousHovered()) {
      <img src="/assets/icons/arrow-left.svg" alt="previous" />
    }
    @if (previousHovered()) {
      <img src="/assets/icons/arrow-left-hover.svg" alt="previous" />
    }
  </button>
  <div class="flex gap-4">
    @for (item of items; track $index; let i = $index) {
      <button
        class="rounded-full hover:bg-white"
        [ngClass]="{
          'bg-white': i === currentIndex && theme !== 'light',
          'bg-linear-to-r from-[#CF9C51] to-[#836231]':
            i === currentIndex && theme === 'light',
        }"
        [attr.aria-label]="'item ' + (i + 1)"
        (click)="onClickAtIndex(i)"
      >
        <div
          class="h-2 md:h-3 lg:h-4 w-2 md:w-3 lg:w-4 rounded-full border transition"
          [ngClass]="{
            'border-white': theme !== 'light',
            'border-[#776B62]': theme === 'light',
          }"
        ></div>
      </button>
    }
  </div>
  <button
    class="w-10 md:w-12 lg:w-14 h-10 md:h-12 lg:h-14 flex flex-col items-center justify-center"
    (click)="onNextIndex()"
    (mouseenter)="checkScreenWidth() > 600 && nextHovered.set(true)"
    (mouseleave)="nextHovered.set(false)"
  >
    @if (!nextHovered()) {
      <img src="/assets/icons/arrow-right.svg" alt="next" />
    }
    @if (nextHovered()) {
      <img src="/assets/icons/arrow-right-hover.svg" alt="next" />
    }
  </button>
</div>
